// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"AddGroup_breadcrumbs__3rykl","breadcrumbsTitle":"AddGroup_breadcrumbsTitle__Nv0km","breadcrumbsList":"AddGroup_breadcrumbsList__r5nn7"};